<template>
  <span class="cursor-pointer select-none inline-block rounded hover:bg-gray-100" @click="onClick()">
    <i class="fas fa-chevron-left" /> {{ $tl(props.label) }}
  </span>
</template>

<script setup>
import {useLanguage, useRouter} from '@front/hooks';

const { t, tl, PREFIX } = useLanguage();
const { router, routerTo } = useRouter();
const props = defineProps({
  to: String,
  label: { type: String, default: 'backToPrevious' },
});

function onClick() {
  if (props.to) {
    routerTo(props.to);
  } else {
    router.back();
  }
}
</script>

<style lang="less"></style>
